<template>
    <div class="warehouse">
        <div class="wh-item" @click="toMenu(item)" v-for="(item,index) in warehouseList" :key="index">
            <div class="wh-content">
                <p>【{{item.warehouseCode}}】</p>
                <p>{{item.warehouseName}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { Icon,Badge } from 'vant';
import { mapMutations } from 'vuex';

export default {
    data() {
        return {
            warehouseList:[]
        }
    },
    components: {
      [Icon.name]: Icon,
      [Badge.name]: Badge,
    },
    created(){
        const user = window.localStorage.user ? JSON.parse(window.localStorage.user) : null;
        this.warehouseList = user.warehouseList.filter((m)=>{
            return [0,1].includes(m.operateType)
        })
    },
    methods: {
        ...mapMutations({
            saveWarehouse: 'saveWarehouse'
        }),
        toMenu(item){
            this.saveWarehouse(item)
            this.$router.push('/mobile/mobileMenu')
        }
    }
}
</script>

<style scoped>
    .warehouse {
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
    }
    .warehouse .wh-item{
        width: 46.6%;
        border: 1px solid #797979;
        background-color: #eaeaea;
        height: 80px;
        text-align: center;
        margin: 1.7%;
        font-size: 13px;
        float: left;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
    }
    .warehouse .wh-item:nth-child(2n){
        margin-right: 0;
    }
    .warehouse .wh-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .warehouse .wh-content p{
        margin: 5px 0;
    }
</style>